import {MaterialFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownGeneric} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useMaterialFilterSection} from '../../shared/useMaterialFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: MaterialFilterSection;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  resetFilter: (slug: string) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionMaterial: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {
    handleMaterialClick,
    materialLabel,
    activeItemIds,
    materialSlug,
    normalizedMaterialValues,
  } = useMaterialFilterSection({
    data,
    activeFilters,
    setFilter,
  });

  return (
    <FilterDropdownGeneric
      activeItemIds={activeItemIds}
      dataTestId={`filterDropdownSection_${materialSlug}`}
      items={normalizedMaterialValues}
      label={materialLabel}
      onAttributeClick={handleMaterialClick}
      onFilterReset={() => resetFilter(materialSlug)}
      onOpen={() => onOpen(materialSlug, filterLabel)}
      onClose={() => onClose(materialSlug, filterLabel)}
      padContent={false}
    />
  );
};
